import { useQuery } from '@apollo/client';

import { GET_FAQ, GET_FAQ_VIDEOS } from './queries';
import { FAQItem, FAQVideo } from './types';

export const useFAQ = () => useQuery<{ frequentlyAskedQuestions: FAQItem[] }>(GET_FAQ);
export const useFAQVideos = () => useQuery<{ faqVideos: FAQVideo[] }>(GET_FAQ_VIDEOS);
